function spbc_timestamp(){
	return Math.floor(+new Date() / 1000);
}

// Hightlights element
function spbcHighlightElement(id, times){
	times = times-1 || 0;
	jQuery('#'+id).addClass('spbc_highlighted');
	jQuery('#'+id).animate({outlineColor: "rgba(255, 0, 0, 1.0)" }, 400, 'linear', function(){
		jQuery('#'+id).animate({outlineColor: "rgba(255, 0, 0, 0.0)" }, 400, 'linear', function(){
			if(times>0){
				spbcHighlightElement(id, times);
			}else{
				jQuery('#'+id).removeClass('spbc_highlighted');
			}
		});
	});
}

function spbc_sendAJAXRequest(data, params, obj){
	
	// Default params
	var button      = params.button      || null;
	var spinner     = params.spinner     || null;
	var progressbar = params.progressbar || null;
	var callback    = params.callback    || null;
	var notJson     = params.notJson     || null;
	var timeout     = params.timeout     || 15000;
	var obj         = obj                || null;
	
	// Button and spinner
	if(button)  {button.setAttribute('disabled', 'disabled'); button.style.cursor = 'not-allowed'; }
	if(spinner) jQuery(spinner).css('display', 'inline');
	
	// Adding security code
	data.security = spbcSettings.ajax_nonce;
	data.no_cache = Math.random();

	jQuery.ajax({
		type: "POST",
		url: spbcSettings.ajaxurl,
		data: data,
		success: function(result){
			if(button){  button.removeAttribute('disabled'); button.style.cursor = 'pointer'; }
			if(spinner)  jQuery(spinner).css('display', 'none');
			if(!notJson) result = JSON.parse(result);
			if(result.error){
				setTimeout(function(){ if(progressbar) progressbar.fadeOut('slow'); }, 1000);
				alert('Security by Cleantalk. Error happens: ' + (result.error || 'Unkown'));
			}else{
				if(callback)
					callback(result, data, params, obj);
			}
		},
		error: function(jqXHR, textStatus, errorThrown){
			if(button){  button.removeAttribute('disabled'); button.style.cursor = 'pointer'; }
			if(spinner) jQuery(spinner).css('display', 'none');
			console.log('SPBC_AJAX_ERROR');
			console.log(jqXHR);
			console.log(textStatus);
			console.log(errorThrown);
		},
		timeout: timeout,
	});
}